import { NSARouterMakerResult } from 'namirasoft-account-react';
import { MessageRow, MessageInputRow } from 'namirasoft-message';
import { MessageEntities } from "../MessageEntities";
import { MessageLayout } from '../MessageLayout';
import { MessageRouterProps } from '../MessageRouterProps';

interface MessageListPageProps extends NSARouterMakerResult, MessageRouterProps
{ }

function MessageListPage(props: MessageListPageProps) 
{
	return (
		<MessageLayout<MessageRow, MessageInputRow> {...props}
			pages={{
				entity: MessageEntities.message(props, true),
				ui: {
					action: {
						menus: {
							view_history: false
						}
					}
				},
				list: {
					ui: {
						tab_page_view: {
							enabled: true,
							tabs: {
								history: false
							}
						},
						getRowAttributes: (row_value) =>
						{
							if (row_value.seen_at)
								return {
									"style": { backgroundColor: "#aaffaa" }
								};
							return {};
						}
					}
				}
			}}
			action={{
				title: "",
				description: "A comprehensive list of messages to keep you informed of important activities across the products and services you use.",
				menus: {}
			}}
		>
			<></>
		</MessageLayout >
	);
}

export default MessageListPage;